var accordionAni = 250;
var sidebarAni = 150;
var sidebarB4Height = 35;
var orbitShowAni = 1000;

/*
//////////////////////////////////////////////////////////////////////////////////////////// JavaScript Plugins
*/
String.prototype.stripHTML = function() {
    return this.replace(/<(?:.|\n)*?>/gm, '');    
}

/*
//////////////////////////////////////////////////////////////////////////////////////////// JavaScript Functions
*/
function transformAnchorLinks(text, target) {
	target = target || "_self";
    var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(exp,"<a href='$1' target='_blank'>$1</a>"); 
}

/*
//////////////////////////////////////////////////////////////////////////////////////////// jQuery Plugins
*/
///// Generic
$.isMobile = function() {
	return $(window).width() <= 767;	
}
///// UI & DOM
$.fn.contentHeight = function() {
	var h = $(this).css("height");
	var dt = $(this).css("display");
	$(this).height("auto");
	$(this).css("display","block");
	var r = $(this)[0].scrollHeight || $(this)[0].clientHeight || $(this).height();
	$(this).height(h);
	$(this).css("display",dt);	
	return r;
}
$.fn.exists = function() {
	return $(this).length != 0;
}
$.fn.heightSpeed = function(base) {
	return base + ($(this).contentHeight() * 1.5);
}
/*
//////////////////////////////////////////////////////////////////////////////////////////// Page Handlers & Animations
*/
function setupAccordions() {

	//Setup Accordions
	$(".accordion .content").not(".show").each(function() {
		$(this).animate({height: 0}, 0, function() {
			$(this).css("display", "none");
		});
	});	
	
	//Setup Accordion Triggers
	$(".accordion .trigger").click(function() {
		var trigger = this;
		var accordion = $(this).closest(".accordion");
		var openContent = $(accordion).find(".content:visible");
		var divCon = $(trigger).next(".content");

		//Actions
		if ($(openContent).exists()) { //Existing Content OPEN, Close Existing, Then Show!
			$(openContent).animate({height: 0}, $(openContent).heightSpeed(accordionAni), function() {
				$(this).css("display","none");
				if (!$(divCon).attr("data-shown") == 1) { //Show IF it wasnt the last element shown
					$(divCon).attr("data-shown", 1);
					$(divCon).css("display","block");
					$(divCon).animate({height: $(divCon).contentHeight()}, $(divCon).heightSpeed(accordionAni));
				}
				$(this).removeAttr("data-shown");
			});
		} else { // NO Existing OPEN Content, - Just Show!
			$(divCon).css("display","block");
			$(divCon).animate({height: $(divCon).contentHeight()}, $(divCon).heightSpeed(accordionAni));
		}
		
	});
	
}

function setupSidebar() {
	
	if ($(".sidebar").exists()) {		
		var sb = $(".sidebar");		
		//Setup
		if ($.isMobile()) {
			$(sb).animate({height: sidebarB4Height}, 0);				
		}
		//Actions
		$(sb).click(function() {
			if ($.isMobile()) { //Is Mobile Viewport
				if ($(sb).height() <= sidebarB4Height) {
					//Show
					$(sb).unbind('click');
					$(sb).prepend('<div class="close">[ Close Submenu ]</div>');
					$(sb).animate({height: $(this).contentHeight()}, $(this).heightSpeed(sidebarAni));
					var closeBtn = $(this).find(".close");
					$(closeBtn).animate({opacity: 1}, 200);
					$(closeBtn).click(function() {
						$(".sidebar").animate({height: sidebarB4Height}, $(this).heightSpeed(sidebarAni), function() {
							$(".sidebar .close").animate({opacity: 0}, 200, function() {
								$(this).remove();
								setupSidebar();
							});							
						});
					});
				} else {
					//Collapse
					$(this).animate({height: sidebarB4Height}, $(this).heightSpeed(sidebarAni));
				}
			}

		});			
	}		
}

var liveServer = '182.160.155.142';

function injectTumblrPosts() {
	var tumblr = $("#tumblr");
	$.ajax({
		crossDomain:true,
		dataType:"json",
		url:"http://"+liveServer+"/tumblr.php",
		data:"json",
		success: function(data,j,x) {
			var posts = (data.posts.length >= 4) ? 4 : data.posts.length;
			for (var i = 0; i < posts; i++) {
				$(tumblr).append('<div class="one-fourth columns mobile-three text-center"><a href="'+data.posts[i]['photo-link-url']+'" target="_blank"><img src="'+data.posts[i]['photo-url-250']+'" alt="'+data.posts[i]['photo-caption'].stripHTML()+'" /></a></div>');
			}
		}, error: function(data) {
			$(tumblr).append('<div class="all columns text-center">Cannot View Tumblr Posts at this Time.</div>');
		}
	});	
}

function injectPinterestPosts() {
	var pinterest = $("#pinterest");
	$.ajax({
		crossDomain:true,
		dataType:"html",
		url:"http://"+liveServer+"/pinterest.php",
		data:"json",
		success: function(data) {
			var items = $(".pin a.ImgLink", data);
			var posts = (items.size() > 4) ? 4 : items.size();
			for (var i = 0; i < posts; i++) {
				var post = $(items).get(i);
				var img = $(post).find("img.PinImageImg");
				$(pinterest).append('<div class="one-fourth columns mobile-three text-center"><a href="http://pinterest.com'+$(post).attr("href")+'" target="_blank"><img style="max-height:226px;" src="'+$(img).attr("src")+'" alt="'+$(img).attr("alt")+'" /></a></div>');				
			}
		}
	});
}

function injectTwitterPosts() {
	var twitter = $("#twitter");
    var url = "https://api.twitter.com/1/statuses/user_timeline.json?include_entities=true&include_rts=true&screen_name=viajiyu&count=5&callback=?";
    $.getJSON(url, function(data){
        var posts = 1; //(data.length >= 4) ? 4 : data.length;
		for (var i = 0; i < posts; i++) {
            var post = data[i];
            var html = 
            '<div class="post white">'+ 
            '<span class="author">'+post.user.name+'</span> ' +
            transformAnchorLinks(post.text) +
            //'<span class="date">' + post.created + '</span>'+
            '</div>';
			$(twitter).append(html);
		}
    });
}

function injectFacebookPosts() {
	var fb = $("#facebook");
    var url = "http://"+liveServer+"/facebook.php";
    $.getJSON(url, function(data){
        var posts = (data.entries.length >= 4) ? 4 : data.entries.length;
    	for (var i = 0; i < posts; i++) {
            var post = data.entries[i];
            var html = 
            '<div class="post black">'+ 
            post.content +
            //'<span class="date">' + post.created + '</span>'+
            '</div>';
			$(fb).append(html);
		}
    });
}


/*
//////////////////////////////////////////////////////////////////////////////////////////// Event Handlers
*/
//HTML DOM Loaded
$(document).ready(function(e) {
	
	//All
	setupAccordions();
	setupSidebar();
	
	//Homepage
	if ($(".homepage").exists()) {
		$('#orbit').orbit({fluid:true, bullets: true, pauseOnHover: true});
		injectTumblrPosts()		
		injectPinterestPosts();
		injectTwitterPosts();
		//injectFacebookPosts();
	}
		
});
//All Content Loaded
$(window).load(function() {
	//Show all Orbit Sliders
	if ($("#orbit").exists()) {
		$("#orbit").animate({opacity:0},0);
		$("#orbit").css("visibility","visible");
		$("#orbit").animate({opacity: 1}, orbitShowAni);
	}
	//Show all Product Sliders
	if ($("#prod-slider").exists()) {
		$("#prod-slider").animate({opacity:0},0);
		$("#prod-slider").css("visibility","visible");
		$("#prod-slider").animate({opacity: 1}, orbitShowAni);
	}	
});